export default __webpack_public_path__ + "static/media/DirtGod.5f23d478.png";